<template>
  <div class="favorite-page-container">
    <TopNavbar title="我的收藏"></TopNavbar>
    <FavoriteFeed></FavoriteFeed>
  </div>
</template>

<script>
  import TopNavbar from "../common/TopNavbar";
  import FavoriteFeed from "./FavoriteFeed";

  export default {
    name: "FavoritePage",
    components: {
      FavoriteFeed,
      TopNavbar,
    },
    mounted() {
    },
    data() {
      return {
      }
    },
    computed: {

    }
  }
</script>

<style lang="scss" scoped>
  .favorite-page-container {
    padding-top: 54px;
    min-height: 100vh;
  }


</style>
